import { render, staticRenderFns } from "./ToS.vue?vue&type=template&id=3e8d4c83"
import script from "./ToS.vue?vue&type=script&lang=js"
export * from "./ToS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports